import { useTranslation } from "react-i18next";
import Select from "../../common/components/Select";
import { realizeEpcrDispositions, useEpcrDispositions } from "../../reducers/epcrDispositionSlice";
import PropTypes from 'prop-types';

export const customCtrlDef = {
    toString: async ({ value, defaultValue, ...props }) => {
        if (!value) {
            return defaultValue;
        }
        let dispositions = await realizeEpcrDispositions({ ...props });
        return dispositions.find(d => d.name == value)?.name ?? value;
    },
    control: ({ value, ...props }) => <EpcrDispositionDropdown disposition={value} {...props}></EpcrDispositionDropdown>
}

const EpcrDispositionDropdown = ({disposition, hideLabel = false, placeholder, disabled = false, required = false, onChange}) => {
    const { t } = useTranslation();
    const dispositions = useEpcrDispositions();

    return <Select hideLabel={hideLabel} disabled={disabled} required={required} placeholder={(placeholder ?? t('dischargeDestination'))+ (required ? ' *' : '')} value={disposition} onChange={onChange} options={dispositions} labelField="name" valueField="name"></Select>
}

EpcrDispositionDropdown.propTypes = {
    disposition: PropTypes.string,
    hideLabel: PropTypes.bool,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    onChange: PropTypes.func
}

export default EpcrDispositionDropdown;